module.exports = __webpack_public_path__ + "static/media/lon_com_ala.5df2d1e9.png";